import { useQuery } from "react-query";
import { getPendingRequestsCount } from "../api/selfonboardingHttpClient";

export const usePendingRequestsCount = () => {
  const { data: count, isLoading, error } = useQuery(
    "pendingRequestsCount",
    getPendingRequestsCount,
    {
      staleTime: Infinity, // Never consider data stale
      cacheTime: Infinity, // Keep in cache forever
      retry: 1,
      onError: (err) => {
        console.error("Failed to fetch pending requests count:", err);
      },
    }
  );

  return {
    count: count ?? 0,
    isLoading,
    error,
  };
};
